import React from 'react'
import './ToggleSwitch.scss'

/**
 * Edited the Toggle so that it reflects the props passed in,
 * instead of always being frozen as the original passed in prop.
 *
 * @param toggleChange the function when the toggle is clicked
 * @param isToggledOn the boolean that should reflect the state of the toggle
 * @returns {JSX.Element}
 */
function BetterToggleSwitch({ onToggleChange, isToggledOn }) {
  return (
    <label className={isToggledOn ? 'toggle-switch' : 'toggle-switch disabled'}>
      <input type="checkbox" checked={isToggledOn} onChange={onToggleChange} />
      <span className="switch" />
    </label>
  )
}

export { BetterToggleSwitch }
